import{pathBuilder}from'config/paths/index';export var root='/admin/request-templates';// Admin Paths
export default pathBuilder(root);